module.exports = __webpack_public_path__ + "img/cajaChicasLinares.06cdad67.svg";